import cx from 'classnames';
import Link from 'next/link';

import Chevrelon from '../../../ui/icons/cheverlon';

const getCheverlon = (routeProps, rotate) => (
  <li>
    <Link
      {...routeProps}
      shallow
      prefetch={false}
      scroll={true}
      className={cx(
        'grid',
        'w-8',
        'h-8',
        'justify-center',
        'items-center',
        'rounded-full',
        'hover:bg-neutral-10'
      )}
    >
      <Chevrelon className={cx('w-3', rotate)} />
    </Link>
  </li>
);

export default getCheverlon;
